import*as e from"react";import{S as t}from"./styled-ec86f3c2.js";import"./_rollupPluginBabelHelpers-c70560be.js";import"./css.js";import"styled-components";import"./styled.js";import"./model.js";import"./theme.js";var r=function(r){return e.createElement(t,r)};export{r as Col};
//# sourceMappingURL=Col.js.map
